import { Link } from "react-router-dom";
import "./NotFound.css";

export default function NotFound() {
  return (
    <div className="not-found-wrapper">
      <div className="not-found-card">
        <img
          src="https://cdn-icons-png.flaticon.com/512/2748/2748558.png"
          alt="404 Icon"
          className="not-found-icon"
        />
        <h1 className="not-found-title">Oops! Page Not Found</h1>
        <p className="not-found-text">
          The page you're looking for doesn’t exist or has been moved.
        </p>
        <Link to="/" className="back-home-btn">
          ⬅ Back to Homepage
        </Link>
      </div>
    </div>
  );
}
